import React, { Component } from "react";
import { animations } from "react-animation";
import {useStore} from 'react-redux';

function MensagemVideoModal(props){

	const i18n = useStore().getState().i18n
	function handleRoute(){
		let code
		if(props.mensagemDeVideo && props.mensagemDeVideo[0]){
			code = props.mensagemDeVideo[0].video.code
		}
		props.navegarMensagemDeVideo(code)
	}

	return (
		<>
		{props.mensagemDeVideo && props.mensagemDeVideo[0] ? (

		<div className={props.visivel === true ? "modal is-active" : "modal"} style={{ animation: animations.popIn }}>
				<div className="modal-background weex-modal-background"></div>
				<div className="modal-card weex-modal-card">
					<header className="modal-card-head weex-modal-card-header">
						<p className="modal-card-title wex-modal-card-title">
							{props.mensagemDeVideo[0].title}
						</p>
						<button onClick={props.handleMensagemDeVideo} className="delete is-large" aria-label="close"></button>
					</header>
					<section className="modal-card-body has-text-centered">
						<div className="weex-modal-card-body__texto">
							{props.mensagemDeVideo[0].image !== null ? <img src={props.mensagemDeVideo[0].image} alt="thumbnail da vídeo mensagem" /> : null}
							<br></br>
					
							{props.mensagemDeVideo[0].message !== null ? <p>{props.mensagemDeVideo[0].message}</p> : null }
						</div>
						<button 
						onClick={handleRoute}
						className="weex-button weex-button__modal">{i18n.message("mensagemvideo.assistir", "Assistir!")}</button>
					</section>
				</div>
			</div>
		) : null}
		</>
	);
}

export default MensagemVideoModal;